import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';


Vue.use(Vuex);
axios.defaults.baseURL = 'https://rezepte.schlagma.de/api/';

export default new Vuex.Store({
    state: {
        personal: {
            lang: localStorage.getItem('lang') || 'browser',
            date: localStorage.getItem('date') || 'browser',
            theme: localStorage.getItem('theme') || 'light',
        },

        colors: {
            mainColor: localStorage.getItem('mainColor') || '#1E7832',
            accentColor: localStorage.getItem('accentColor') || '#B46432',
        },

        tokenValidUntil: localStorage.getItem('tokenValidUntil') || 0,

        apiURL: '/api/',

        mobileSidebarVisible: false,
        btnSidebarVisible: false,
        headerNavVisible: false,
        menuVisible: false,

        loginLoading: false,
        upWrong: false,
        forwardRoute: '',

        infoBoxText: '',

        recipeList: [],
        recipeListShown: [],
        recipeListStatus: 'loading',

        docsURL: 'https://docs.kulini.schlagma.de/',
    },
    actions: {
        destroyToken(context) {
            return new Promise((resolve, reject) => {
                axios.post('logout', localStorage.getItem('refreshToken'))
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            });
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                this.state.loginLoading = true;
                axios.post('login', {
                    username: credentials.username,
                    password: credentials.password,
                })
                .then((response) => {
                    const message = response.data.message;
                    if (message === 'Login successful') {
                        const accessToken = response.data.accessToken;
                        const refreshToken = response.data.refreshToken;
                        const displayName = response.data.displayName;
                        const role = response.data.role;
                        const tokenValidUntil = response.data.tokenValidUntil;

                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('refreshToken', refreshToken);
                        localStorage.setItem('username', credentials.username);
                        localStorage.setItem('displayName', displayName);
                        localStorage.setItem('role', role);
                        localStorage.setItem('tokenValidUntil', tokenValidUntil);
                        this.state.tokenValidUntil = tokenValidUntil;

                        resolve(response);

                        this.state.loginLoading = false;
                    } else {
                        this.state.upWrong = true;
                        this.state.loginLoading = false;
                    }
                })
                .catch((error) => {
                    reject(error);
                });
            });
        },
        refreshAccessToken() {
            return new Promise((resolve, reject) => {
                axios.post('refresh', { username: localStorage.getItem('username'), refreshToken: localStorage.getItem('refreshToken') })
                .then((response) => {
                    localStorage.setItem('accessToken', response.data.accessToken);
                    localStorage.setItem('refreshToken', response.data.refreshToken);
                    localStorage.setItem('tokenValidUntil', response.data.tokenValidUntil);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            });
        },
        getRecipeList() {
            return new Promise((resolve, reject) => {
                axios.get('recipes/get/all').then((response) => {
                    this.state.recipeList = response.data.map((val: any) => ({
                        id: val.id,
                        title: val.title,
                        image: val.image,
                        forValue: val.forValue,
                        forType: val.forType,
                        categories: val.categories,
                        editedon: val.editedon,
                    }));
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
    },
});
